import type { List } from '@/utils/list';

export const DEFAULT_BUDGET_CURRENCY = 'USD';

export interface AmountDto {
  number: string;
  currency: string;
}

export interface SingleBudgetDto {
  id: string;
  service_id: string;
  expenses_category: string;
  planned_budget: AmountDto;
  year: number;
  created_at: string;
  updated_at: string;
}

export type BudgetsListDto = List<SingleBudgetDto>;

export interface UpsertBudgetDto {
  expenses_category: string;
  planned_budget: AmountDto;
  year: number;
}

export interface UpdateBudgetDto {
  planned_budget: AmountDto;
}

export interface BulkUpsertBudgetRowDto {
  expenses_category: string;
  planned_budget: AmountDto;
}

export interface BulkUpsertBudgetsDto {
  budgets: BulkUpsertBudgetRowDto[];
}

export interface Amount {
  number: string;
  currency: string;
}

export interface SingleBudget {
  id: string;
  serviceId: string;
  expensesCategory: string;
  plannedBudget: Amount;
  year: number;
  createdAt: string;
  updatedAt: string;
}

export type BudgetsList = List<SingleBudget>;

export interface UpsertBudgetValues {
  expensesCategory: string;
  plannedBudget: number;
  year: number;
  currency?: string;
}

export interface UpdateBudgetValues {
  plannedBudget: number;
  currency?: string;
}

export interface BulkUpsertBudgetRow {
  expensesCategory: string;
  plannedBudget: number;
}

export interface BulkUpsertBudgetValues {
  year: number;
  budgets: BulkUpsertBudgetRow[];
  currency?: string;
}
